export default __webpack_public_path__ + "static/media/heineken-logo.771f68b6.png";